import { handleActions } from 'redux-actions'
import crmActions from 'actions/crm'
import { setKeyBy } from 'utils/reducers'
import initialState from './initial.state'

export default handleActions({
  [crmActions.keywords.set]: setKeyBy()
}, initialState.keywords)
